import { PathCreateScreen } from '@/features/unified-learning/runtime/screens/PathCreateScreen';

export default function LearnPathCreateRoute() {
  return <PathCreateScreen />;
}
